module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_MURS_CHROMATIC_CH2_1066.f51a85cf.png";